import { isObject } from "../helpers/general.js";
const isOverridesProxy = Symbol("isOverridesProxy");
const createOverridesProxy = (targetObject, overrides) => {
  if (!targetObject || typeof targetObject !== "object") {
    return targetObject;
  }
  const handler = {
    get(target, prop, receiver) {
      if (prop === isOverridesProxy) {
        return true;
      }
      if (prop === TARGET_SYMBOL) {
        return target;
      }
      const value = Reflect.get(target, prop, receiver);
      if (!isObject(value)) {
        return Reflect.get(overrides ?? {}, prop) ?? value;
      }
      return createOverridesProxy(value, Reflect.get(overrides ?? {}, prop));
    },
    set(target, prop, value, receiver) {
      if (prop === isOverridesProxy || prop === TARGET_SYMBOL) {
        return false;
      }
      const hasOverride = overrides && Reflect.has(overrides, prop);
      if (hasOverride && overrides && typeof overrides === "object") {
        ;
        overrides[prop] = value;
        return true;
      }
      return Reflect.set(target, prop, value, receiver);
    }
  };
  return new Proxy(targetObject, handler);
};
const TARGET_SYMBOL = Symbol("overridesProxyTarget");
function unpackOverridesProxy(obj) {
  if (obj[isOverridesProxy]) {
    return obj[TARGET_SYMBOL];
  }
  return obj;
}
export {
  TARGET_SYMBOL,
  createOverridesProxy,
  unpackOverridesProxy
};
//# sourceMappingURL=overrides-proxy.js.map
